import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/salarypackagingproviders');
}
//Get all active
export function allActive(){
    return http().get('/salarypackagingproviders/active');
}
//Get Single
export function single(id){
    return http().get(`/salarypackagingproviders/${id}`);
}
//Add one
export function add(data){
    return http().post('/salarypackagingproviders', data)
}
//Update
export function update(id, data){
    return http().put(`/salarypackagingproviders/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/salarypackagingproviders/${id}`);
}
